import axios from 'axios';
import has from 'lodash/has';
import get from 'lodash/get';

//Libs
import { Consequence } from '../../libs/utils';

//Endpoints
import { LOGIN } from '../../constants/endpoints';

//Actions 
export const ACTIVE_ADMIN = 'ACTIVE_ADMIN';
export const CLEAR_ADMIN  = 'CLEAR_ADMIN';

/**
* Acción de redux que modifica el estado admin
* @param  {Object} payload {email, password} Información necesaria para hacer Login
* @return {Promise}        Promesa con la información que se va a actualizar en redux  
*/
export function logInSuperAdmin(payload) {
  payload.time_zone = new Date().getTimezoneOffset();

  return dispatch => axios.post(LOGIN, payload)
    .then(res => {
      const isSuperAdmin = has(get(res, 'data.data'), 'access_token_admin');

      if (isSuperAdmin) {
        return new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data') },
          eventTypes: { success: ACTIVE_ADMIN, error: 'ERROR' }
        })
      } else {
        throw new Error('Acceso denegado');
      }

    })
    .catch(error => {
      throw error;
    })
}

export function clearAdmin() {
  return (dispatch) => Promise.resolve(dispatch({ 
    type: CLEAR_ADMIN, 
    payload: null 
  }))

} // END clearToken


// WEBPACK FOOTER //
// ./src/redux/actions/adminActions.js